const menu = document.querySelector('nav');
const mobileMenu = document.getElementById('menu-mobile');
const menuElem = document.getElementById('menu');
let top = '0px';

if (menuElem) {
    top = `${menuElem.getBoundingClientRect().bottom}px`;
}

// if not null, and the user clicks outside this element, then close the active menu
let activeMenu = null;

const opts = {
    bubbles: true,
};

function isElementInsideMenu(el) {
    let node = el;

    while (node) {
        if (node === mobileMenu
            || (node.nodeName === 'BUTTON' && node.classList.contains('nav-menu-item'))) {
            return true;
        }

        node = node.parentNode;
    }

    return false;
}

document.addEventListener('click', (evt) => {
    const controls = activeMenu && activeMenu.getAttribute('aria-controls');

    if (!activeMenu || ['mini-context-selector', 'menu-mobile'].indexOf(controls) !== -1) {
        // no menu opened, or the mobile menu is open
        return;
    }

    if (!isElementInsideMenu(evt.target)) {
        closeActiveMenu();
    }
});

// Calling node.dispatchEvent(eventMenuOpen/Close)
//   - (handleMenuOpen)    Toggles aria-expanded on the nav menu item
//   - (handleSubmenuOpen) Toggles aria-expanded on the ul[role=menu] submenu
//   - (handleSubmenuOpen) Reposition ul[role=menu] submenu
//   - (handleSubmenuOpen) Toggles aria-expanded on the footer#menu-mobile

const eventMenuOpen         = new CustomEvent('menu.open', opts);
const eventMenuClose = new CustomEvent('menu.close', opts);

function handleMenuOpen(e) {
    const node = e.target;
    node.setAttribute('aria-expanded', true);
}

function handleSubmenuOpen(e) {
    const menuItem = e.target;

    const id = menuItem.getAttribute('aria-controls');
    if (!id) return console.warn('Unable to expand submenu [element %s is missing property aria-controls]', menuItem.id);

    // target may not necessarily be a submenu
    const subMenuList = document.getElementById(id);
    if (!subMenuList) return console.warn('Unable to expand submenu %s [target menu does not exist]', id);

    expandItemFor(subMenuList, menuItem);

    if (subMenuList !== mobileMenu && isWithin(subMenuList, mobileMenu)) {
        expandItemFor(mobileMenu, menuItem);
        const targetRect = menuItem.getBoundingClientRect();
        const nodeRect = subMenuList.getBoundingClientRect();
        subMenuList.style.top = top;
        subMenuList.style.left = `${targetRect.left + nodeRect.width > window.innerWidth ? targetRect.right - nodeRect.width : targetRect.left}px`;
        subMenuList.focus();
    }

    if (subMenuList === mobileMenu) {
        document.body.classList.add('mobile-menu-visible');
    }

    activeMenu = menuItem;
}

function handleMenuClose(e) {
    const menuItem = e.target;
    revertExpand(menuItem);
    menuItem.setAttribute('aria-expanded', false);
    activeMenu = null;
}

function handleSubmenuClose(e) {
    const menuItem = e.target;
    revertExpand(menuItem);
    document.body.classList.remove('mobile-menu-visible');
}

document.addEventListener('menu.open',  handleMenuOpen);
document.addEventListener('menu.open',  handleSubmenuOpen);
document.addEventListener('menu.close', handleMenuClose);
document.addEventListener('menu.close', handleSubmenuClose);

function handleMenuItemClicked(evt) {
    const menuItem = this;
    const targetId = menuItem.getAttribute('aria-controls');
    const currentOpenMenu = menu.querySelector('.nav-menu-item[aria-expanded=true]');

    if (currentOpenMenu) currentOpenMenu.dispatchEvent(eventMenuClose);

    if (!targetId && menuItem.hasAttribute('href')) {
        return;
    }

    if (menuItem !== currentOpenMenu) {
        // don't reopen the menu if we just closed it
        menuItem.dispatchEvent(eventMenuOpen);
    }

    // don't jump to URL
    evt.preventDefault();
}

function closeActiveMenu() {
    const currentOpenMenu = menu.querySelector('.nav-menu-item[aria-expanded=true]');

    if (currentOpenMenu) currentOpenMenu.dispatchEvent(eventMenuClose);
}

const menuItems = document.querySelectorAll('nav .nav-menu-item[aria-controls]');

Array.from(menuItems).forEach((menuItem) => {
    menuItem.addEventListener('click', handleMenuItemClicked);
});

window.addEventListener('resize', closeActiveMenu);

function isWithin(el, ancestor) {
    // some random number, strip the 0. from the start
    if (!el.id) el.id = (`${Math.random()}`).substr(2);
    return !!ancestor.querySelector(`#${el.id}`);
}

function expandItemFor(expanded, instigator) {
    expanded.setAttribute('aria-expanded', true);

    const dataExpanded = instigator.getAttribute('data-expanded') || '';
    instigator.setAttribute('data-expanded', `${dataExpanded} ${expanded.id}`);
}

function revertExpand(instigator) {
    const expandeds = (instigator.getAttribute('data-expanded') || '').split(' ');

    expandeds.forEach((expanded) => {
        // ignore blanks
        if (!expanded) return;
        expanded = document.getElementById(expanded);

        if (!expanded) {
            console.warn('Unable to revert expanded state [element %s does not exist]', expanded);
            return;
        }

        const state = expanded.getAttribute('aria-expanded');

        if (state === 'true') {
            expanded.setAttribute('aria-expanded', false);
        } else if (state === 'false') {
            expanded.getAttribute('aria-expanded', true);
        } else {
            console.warn('Unable to revert expanded state [element %s does not have aria-expanded set]', expanded);
        }
    });

    instigator.removeAttribute('data-expanded');
}

const logoDiv = document.querySelector('nav#menu #logo');

if (logoDiv) {
    logoDiv.addEventListener('click', (evt) => {
        evt.preventDefault();

        if (window.location.pathname.includes('/past-employees')) {
            window.location.reload(true);
        } else {
            window.location = document.head.querySelector('base').getAttribute('href');
        }
    });
}

document.addEventListener('DOMContentLoaded', () => {
    document.addEventListener('aurion-app-reload', () => {
        document.location.reload(true);
    });
});

export default eventMenuClose;
